// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3l2Wm","options":"AnswerScale_options__2JjFj","selected":"AnswerScale_selected__1yeK-"};